import React, { Component } from "react";
import PropTypes, { object } from "prop-types";
import AWS from "aws-sdk";
import "./S3Uploader.css";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import * as constants from "../../../store/constants";
import { connect } from "react-redux";
import { Loader } from "../../../store/actions/authActionCreators";
import Alert from '@material-ui/lab/Alert';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { v4 as uuidv4 } from 'uuid';
import { getEnv } from "../../site-config/CrossSiteConfigs";
import { getPreSignedDocument } from '../../../store/actions/userActionCreators';
import * as logger from '../../../logger';

const s3UploaderCss = (theme) => ({
  vendorBalanceAmount: {
    fontSize: 14,
    fontWeight: 600,
    color: "#0b1323",
    float: "left",
  },
});

class S3Uploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      file: "",
      message: "",
      toggle: props.toggle ? props.toggle : false,
      text: props.text ? props.text : null,
      fromDocumentFlag: props.fromDocumentBook ? props.fromDocumentBook : false,
      fromDocumentBookImage: props.fromDocumentBookImage ? props.fromDocumentBookImage : false,
      id: props.id ? props.id : "",
      profilePhoto: false,
      profilePicture: "",
      checkFileType: false,
      sizeFlag: false,
      fromAddCompanyDetailsDialog: props.fromAddCompanyDetailsDialog ? props.fromAddCompanyDetailsDialog : false,
      fromAddCompanyDetailsDialogEdit: props.fromAddCompanyDetailsDialogEdit ? props.fromAddCompanyDetailsDialogEdit : false,
      fromBiltyCompanyDetails: props.fromBiltyCompanyDetails ? props.fromBiltyCompanyDetails : false,
      fromBiltySignature: props.fromBiltySignature ? props.fromBiltySignature : false,
      fromProfileAccounts: props.fromProfileAccounts ? props.fromProfileAccounts : false,
      displayErrorMessageBelow: props.displayErrorMessageBelow ? props.displayErrorMessageBelow : false,
      fromSingleInvoiceEditSignature: props.fromSingleInvoiceEditSignature ? props.fromSingleInvoiceEditSignature : false,
      fromSingleInvoiceAddSignature: props.fromSingleInvoiceAddSignature ? props.fromSingleInvoiceAddSignature : false,
      fromSingleInvoice: props.fromSingleInvoice ? props.fromSingleInvoice : false,
      directoryName: props.directoryName ? props.directoryName : "dweb-images"
    };

  }

  inputElement = null;
  componentDidMount() {

    if (this.props.handleToggle == true) {
      this.setState({ toggle: true });
    }

    if (this.props.handleProfile == true) {
      this.setState({ profilePhoto: true });
    }
    if (this.props.enableClick) {
      if (this.inputElement) {
        this.inputElement.click();
      }
    }

  }

  // ********************************** Function to upload image into s3 **********************************
  imageUploadForm(fileInfo, apiResponse, params) {

    this.props.dispatchToggleLoader({ type: constants.TOGGLE_LOADER });

    // ************************************** Setting required post request headers **************************************
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", true);
    myHeaders.append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");

    // Creating Form data object .
    const formdata = new FormData();

    // Adding required data into form data object.
    params.forEach((element) => {
      formdata.append(element.inputName, element.inputValue)
    });

    // Appending input type file from data object into the existing form data object.
    formdata.append('file', fileInfo[0]);

    // API request option (structure) to upload into s3
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata
    };

    // Uploading to s3 and returning a promise. :).....
    return (fetch(apiResponse && apiResponse.url ? apiResponse.url : "", requestOptions)
      .then(response => {
        if (response && response.status && response.status == 204) {
          return "upload-successfull"
        }
      })
      .catch(error => {
        logger.log('s3Uploader error ', error)
        return "upload-failed"
      })
    );

  }


  onChangeFile = (event) => {
    let menv = "Production"
    if (process.env.REACT_APP_ENV == 'staging') {
      menv = "Staging"
    }

    // *************** Fetching file object from input type file html tag ***************
    const { files } = this.state.fromSingleInvoice || this.state.fromSingleInvoiceAddSignature || this.state.fromSingleInvoiceEditSignature || this.state.fromProfileAccounts || this.state.fromBiltySignature || this.state.fromAddCompanyDetailsDialog || this.state.fromAddCompanyDetailsDialogEdit || this.state.fromBiltyCompanyDetails ? document.getElementById(this.state.id ? this.state.id : "addCompanyDetails") : this.state.fromDocumentBookImage ? document.getElementById("photoupload2") : this.state.fromDocumentFlag ? document.getElementById(this.state.id ? this.state.id : "photoupload1") : document.getElementById(this.state.id ? this.state.id :"photoupload");

    if (!files.length) {
      if (typeof this.statusMessage == 'function') {
        return this.statusMessage("Please choose a file to upload first.");
      }
      return null
    }

    const file = files[0];
    let fileName = file.name;
    const checkFile = fileName.split(".");
    const checkFileLength = checkFile ? checkFile.length : "";
    let uuid = uuidv4();
    if (typeof uuid != 'undefined' && uuid && uuid.length > 0) {
      fileName = `${uuid}.${checkFile[checkFileLength - 1]}`;
    }

    if (checkFile[checkFileLength - 1] == ("jpg" || "JPG") || checkFile[checkFileLength - 1] == ("jpeg" || "JPEG") || checkFile[checkFileLength - 1] == ("png" || "PNG")) {
      this.setState({ checkFileType: false });
      if (((file.size / 1024) / 1024) <= 5) {

        // **** Presigned API request ****
        const requestData = {
          fileType: checkFile[checkFileLength - 1],
          directory: this.props.tbookBucketName + "/" + this.props.directoryName,
          bucketName: "tpbook"
        }

        this.setState({ sizeFlag: false });

        // ****************************** Fetching the credential details of presigned URL from backend ******************************
        this.props.dispatchGetPreSignedDocument(
          requestData,
          (data) => {
            if (data && data.status && data.status.code == 200 && data.response && data.response.data && data.response.data.fields && data.response.data.fields.policy) {

              const responseData = data.response.data.fields;

              // ******************************************* Upload form data objects *******************************************
              const postFormData = [
                { inputType: "input", inputName: "bucket", inputValue: 'tpbook' },
                { inputType: "input", inputName: "key", inputValue: responseData && responseData.key ? responseData.key : "" },
                { inputType: "hidden", inputName: "acl", inputValue: responseData && responseData.acl ? responseData.acl : "" },
                { inputType: "input", inputName: "Content-Type", inputValue: responseData && responseData["Content-Type"] ? responseData["Content-Type"] : "" },
                { inputType: "text", inputName: "x-amz-credential", inputValue: responseData && responseData["x-amz-credential"] ? responseData["x-amz-credential"] : "" },
                { inputType: "text", inputName: "x-amz-algorithm", inputValue: responseData && responseData["x-amz-algorithm"] ? responseData["x-amz-algorithm"] : "" },
                { inputType: "text", inputName: "x-amz-date", inputValue: responseData && responseData["x-amz-date"] ? responseData["x-amz-date"] : "" },
                { inputType: "hidden", inputName: "Policy", inputValue: responseData && responseData.policy ? responseData.policy : "" },
                { inputType: "hidden", inputName: "x-amz-signature", inputValue: responseData && responseData["x-amz-signature"] ? responseData["x-amz-signature"] : "" },
              ]

              // ************************** Promise returning function to upload into s3. **************************
              this.imageUploadForm(files, data.response.data, postFormData).then(response => {
                setTimeout(() => {
                  this.props.dispatchToggleLoader({ type: constants.TOGGLE_LOADER });
                }, 1000)
                if (response == "upload-successfull") {
                  this.props.handleFile(data.response.url);
                }
              })

            }
          },
          () => {
            this.props.dispatchToggleLoader({ type: constants.TOGGLE_LOADER });
          }
        )
      }
      else {
        // Setting variable to display error when image size is above 5MB.
        this.setState({ sizeFlag: true });
        if (this.state.displayErrorMessageBelow) {
          this.props.displayErrorBelow({
            checkFileType: false,
            sizeFlag: true
          });
        }
      }
    } else {
      // Setting variable to display error when file type is not image.
      this.setState({ checkFileType: true });
      if (this.state.displayErrorMessageBelow) {
        this.props.displayErrorBelow({
          checkFileType: true,
          sizeFlag: false
        });
      }
    }
  };

  setPhotoLink = () => {
    if (this.props.link) {
      this.setState({ profilePicture: this.props.link });
    }

  }

  render() {
    const { file, message, loader } = this.state;
    const { buttonName } = this.props;

    if (this.state.profilePhoto && (this.props.link || this.state.profilePicture)) {
      var profile = this.props.link || this.state.profilePicture;
    }

    return (
      <>
        <div className="divDisplay">
          <div className="S3Uploader">
            {/* <form id="form-upload"> */}
              <div className="S3Uploader-content">

                {!this.state.fromProfileAccounts && !this.state.fromBiltySignature && !this.state.fromDocumentFlag && !this.state.fromDocumentBookImage && !this.state.fromAddCompanyDetailsDialog && !this.state.fromAddCompanyDetailsDialogEdit && !this.state.fromBiltyCompanyDetails && !this.state.fromSingleInvoiceEditSignature && !this.state.fromSingleInvoiceAddSignature && !this.state.fromSingleInvoice &&
                  <>
                    {
                      this.state.profilePhoto ?
                        (
                          <>
                            <div>
                              <div style={{ width: '65px', height: '65px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e4e4e4', border: '2px solid white', borderRadius: '8px', marginLeft: '24px', marginTop: '-16px', cursor: 'pointer' }}>

                                {profile ?
                                  (
                                    <img src={profile} style={{ width: '65px', height: '65px', borderRadius: '8px', border: '1px solid white' }}></img>
                                  )
                                  :
                                  (
                                    <PhotoCameraIcon style={{ color: '#909090', fontSize: '33px' }} />
                                  )
                                }
                              </div>
                              <input
                                type="file"
                                name="file"
                                id="photoupload"
                                onChange={this.onChangeFile}
                                accept="image/*"
                                className="inputProfile"
                              />
                            </div>
                          </>
                        )
                        :
                        (
                          <>
                            <div className="S3Uploader-service">
                              <IconButton
                                color="inherit"
                                aria-label="close"
                                style={{ padding: "7px 12px" }}
                              >
                                <AddAPhotoIcon style={{ color: '#0033cc', fontSize: 16 }} />
                                {this.state.toggle && <div id="addPhotoText" className="S3Uploader-divV1">{this.state.text ? this.state.text : 'Add Image'}</div>}
                              </IconButton>
                              <input
                                type="file"
                                name="file"
                                id={this.state.id ? this.state.id : 'photoupload'}
                                ref={input => this.inputElement = input}
                                onChange={this.onChangeFile}
                                accept="image/*"
                              />
                            </div>
                          </>
                        )
                    }
                  </>
                }

                {this.state.fromDocumentFlag &&
                  <>
                    <div className="S3Uploader-service1">

                      <div className="divIcon">
                        <AddAPhotoIcon className="colorV1" />
                      </div>

                      <input
                        type="file"
                        name="file"
                        id={this.state.id ? this.state.id : 'photoupload1'}
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }

                {this.state.fromDocumentBookImage &&
                  <>
                    <div className="S3Uploader-service">
                      <IconButton
                        color="inherit"
                        aria-label="close"
                        style={{ padding: "7px 12px" }}
                      >
                        <AddAPhotoIcon style={{ color: '#0033cc', fontSize: 16 }} />
                      </IconButton>
                      <input
                        type="file"
                        name="file"
                        id="photoupload2"
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }

                {this.state.fromAddCompanyDetailsDialog &&
                  <div className="S3Uploader-service">
                    <Button
                      color="inherit"
                      aria-label="close"
                      style={{ color: 'white', backgroundColor: '#5170f0', borderRadius: 4, paddingLeft: 24, paddingRight: 24, paddingTop: 10, paddingBottom: 10, fontSize: 10, textTransform: 'capitalize' }}
                    >
                      <AddAPhotoIcon style={{ fontSize: 16, color: 'white', marginTop: -5 }} />
                      <span style={{ fontSize: 12, fontWeight: 500, marginLeft: 12 }}>Add Logo</span>
                    </Button>
                    <input
                      type="file"
                      name="file"
                      // id="addCompanyDetails"
                      id={this.state.id ? this.state.id : 'addCompanyDetails'}
                      ref={input => this.inputElement = input}
                      onChange={this.onChangeFile}
                      accept="image/*"
                    />
                  </div>
                }

                {this.state.fromAddCompanyDetailsDialogEdit &&
                  <>
                    <div className="S3Uploader-service-addcomppanydetails">
                      <IconButton style={{
                        borderRadius: '0px !important',
                        width: 24,
                        height: 24,
                        backgroundColor: '#f1f1f3',
                        borderRadius: 4,
                        '&:hover': {
                          backgroundColor: '#f1f1f3',
                        }
                      }}>
                        <EditIcon style={{ fontSize: 16, color: '#5170f0' }} />
                      </IconButton>
                      <input
                        type="file"
                        name="file"
                        id={this.state.id ? this.state.id : 'addCompanyDetails'}
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }

                {this.state.fromBiltyCompanyDetails &&
                  <>
                    <div className="S3Uploader-service-biltyCompantDetails">
                      <IconButton style={{
                        borderRadius: '0px !important',
                        width: 24,
                        height: 24,
                        backgroundColor: '#f1f1f3',
                        borderRadius: 4,
                        '&:hover': {
                          backgroundColor: '#f1f1f3',
                        }
                      }}>
                        <EditIcon style={{ fontSize: 16, color: '#5170f0' }} />
                      </IconButton>
                      <input
                        type="file"
                        name="file"
                        id={this.state.id ? this.state.id : 'addCompanyDetails'}
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }

                {this.state.fromBiltySignature && this.state.id !== "addBiltySignatureChange" &&
                  <>
                    <div className="S3Uploader-service3">
                      <Button variant="outlined" className="upload-button" startIcon={<AddIcon className="add-icon" />} >
                        Upload Signature
                      </Button>
                      <input
                        type="file"
                        name="file"
                        id={this.state.id ? this.state.id : 'addCompanyDetails'}
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }

                {this.state.fromBiltySignature && this.state.id == "addBiltySignatureChange" &&
                  <>
                    <div className="S3Uploader-service3">
                      <Button variant="outlined" className="change-button" >
                        Change
                      </Button>
                      <input
                        type="file"
                        name="file"
                        id={this.state.id ? this.state.id : 'addCompanyDetails'}
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }
                {this.state.fromProfileAccounts &&
                  <>
                    <div className="S3Uploader-service-accountDetails">
                      <IconButton style={{
                        borderRadius: '0px !important',
                        width: 24,
                        height: 24,
                        backgroundColor: '#f1f1f3',
                        borderRadius: 4,
                        '&:hover': {
                          backgroundColor: '#f1f1f3',
                        }
                      }}>
                        <EditIcon style={{ fontSize: 16, color: '#6b778c' }} />
                      </IconButton>
                      <input
                        type="file"
                        name="file"
                        id={this.state.id ? this.state.id : 'addCompanyDetails'}
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }

                {this.state.fromSingleInvoiceEditSignature && this.state.id == "changeSignature" &&
                  <div className="S3Uploader-service3">
                    <Button variant="outlined" className="change-button-signature" >
                      Change
                    </Button>
                    <input
                      type="file"
                      name="file"
                      id={this.state.id ? this.state.id : 'fromInvoice'}
                      ref={input => this.inputElement = input}
                      onChange={this.onChangeFile}
                      accept="image/*"
                    />
                  </div>
                }

                {this.state.fromSingleInvoiceAddSignature && this.state.id == "addSignature" &&
                  <div className="S3Uploader-service4">
                    <Button variant="outlined" className="add-button-signature" >
                      + Add Signature
                    </Button>
                    <input
                      type="file"
                      name="file"
                      id={this.state.id ? this.state.id : 'fromInvoice'}
                      ref={input => this.inputElement = input}
                      onChange={this.onChangeFile}
                      accept="image/*"
                    />
                  </div>
                }

                {this.state.fromSingleInvoice && this.state.id == "addLogo" &&
                  <div className="S3Uploader-service3">
                    <Button variant="outlined" className="add-invoice-logo-button" classes={{ label: "add-invoice-logo-button-label" }} >
                      <AddAPhotoIcon className="invoice-camera-icon" />
                      <div className="invoice-textV1">+ Add Logo</div>
                    </Button>
                    <input
                      type="file"
                      name="file"
                      id={this.state.id ? this.state.id : 'addPhoto'}
                      ref={input => this.inputElement = input}
                      onChange={this.onChangeFile}
                      accept="image/*"
                    />
                  </div>
                }

                {this.state.fromSingleInvoice && this.state.id == "editLogo" &&
                  <>
                    <div className="S3Uploader-service-edit-logo-invoice">
                      <IconButton className="edit-invoice-button" >
                        <EditIcon className="edit-invoice-icon" />
                      </IconButton>
                      <input
                        type="file"
                        name="file"
                        id={this.state.id ? this.state.id : 'addCompanyDetails'}
                        ref={input => this.inputElement = input}
                        onChange={this.onChangeFile}
                        accept="image/*"
                      />
                    </div>
                  </>
                }

              </div>
            {/* </form> */}

            <div className="S3Uploader-message">
              <span>{message > 0 ? message : null}</span>
            </div>
          </div >
          {!this.state.displayErrorMessageBelow &&
            <>
              {this.state.checkFileType &&
                <Alert severity="error" className="mtV1">Please select only .jpg, .jpeg and .png files</Alert>
              }
              {this.state.sizeFlag &&
                <Alert severity="error" className="mtV1">File size must be below 5MB.</Alert>
              }
            </>
          }
        </div>
      </>
    );
  }
}



S3Uploader.defaultProps = {
  buttonName: "Upload File",
  bucketRegion: "ap-south-1",
  tbookBucketName: "tpbook",
  IdentityPoolId: "ap-south-1:00000000-0000-0000-0000-000000000000",
};

S3Uploader.propTypes = {
  buttonName: PropTypes.string,
  bucketRegion: PropTypes.string,
  tbookBucketName: PropTypes.string.isRequired,
  IdentityPoolId: PropTypes.string.isRequired,
  handleFile: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchToggleLoader: (type) => dispatch(Loader(type)),
  dispatchGetPreSignedDocument: (data, onSuccess, onError) => {
    dispatch(getPreSignedDocument(data, onSuccess, onError))
  }
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(S3Uploader);
